import { useReduxState } from 'hooks';
import { Checkbox, FormGroup } from 'components/common/form';
import { SiteSettingsForm } from '.';

const SiteSettingsPaths = () => {
  const { messages, serverConfig } = useReduxState();

  const { pathEnableSignUpLink } = serverConfig;

  const initialValues = {
    pathEnableSignUpLink
  };

  return (
    <div className="settings-common">
      <SiteSettingsForm
        initialValues={initialValues}
        title={messages.commonPaths}
      >
        {() => (
          <div>
            <FormGroup
              htmlFor="individual-achievements-display-for-admins"
              label={messages.commonSharing}
            >
              <Checkbox
                field="pathEnableSignUpLink"
                id="path-enable-sign-up-link"
                label={messages.pathSignUpLinkEnable}
              />
            </FormGroup>
          </div>
        )}
      </SiteSettingsForm>
    </div>
  );
};

export default SiteSettingsPaths;
